import { ReactElement, useContext } from 'react';
import { getGiveawayAssets, GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { GiveawayContext } from '@/state/state';
import { ImageGallery } from '../gallery/gallery';
import { CLUSTER_BUTTON_TYPES } from '@/enums/ClusterButton';

export const Interior = (): ReactElement | null => {
  const giveawayData: GiveawayResponse = useContext(GiveawayContext);
  const assets: string[] = getGiveawayAssets(giveawayData, 'interior');

  if (!assets?.length) {
    return null;
  }

  return (
    <ImageGallery
      assets={assets}
      labelPrefix="Interior"
      name={CLUSTER_BUTTON_TYPES.INTERIOR}
      displaySubTitle
    />
  );
};
